import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { device } from "./device.js";

import Lottie from "react-lottie-player";
import animationData from "../assets/sharejoy_lennie_loading/sharejoy_lennie_loading.json";

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    font-family: 'Nunito', sans-serif;
  }
`;

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #f9dcb6;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLottie = styled(Lottie)`
  width: 70%;
  height: auto;
  @media ${device.mobileXS} {
    width: 70%;
  }
  @media ${device.mobileS} {
    width: 75%;
  }
  @media ${device.mobileM} {
    width: 80%;
  }
  @media ${device.mobileL} {
    width: 60%;
  }
`;
const LoadingPage = () => {
  return (
    <>
      <GlobalStyle />
      <Wrapper>
        <StyledLottie
          loop
          play
          animationData={animationData}
          rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        />
      </Wrapper>
    </>
  );
};

export default LoadingPage;
